import React from "react";
import get from "lodash/get";
import Grid from "@mui/material/Grid";

import { titles, errorMsgs } from "./constants";

import { StyledCompanyDetailsWrapper, StyledTitle, StyledErrorMsg } from "./styled";

export const CompanyDetails = ({ prospectOverview = {}, searchResult }) => {
  return (
    <>
      <StyledTitle>{titles.APPLICANT_DETAIL_TITLE}</StyledTitle>
      {prospectOverview.applicantInfo ? (
        <Grid container spacing={3}>
          <Grid item md={6} sm={12}>
            <StyledCompanyDetailsWrapper>
              {prospectOverview.applicantInfo.email}
            </StyledCompanyDetailsWrapper>
          </Grid>
          <Grid item md={6} sm={12}>
            <StyledCompanyDetailsWrapper>
              {`${get(prospectOverview, "applicantInfo.countryCode", "")} ${get(
                prospectOverview,
                "applicantInfo.mobileNo",
                ""
              )}`}
            </StyledCompanyDetailsWrapper>
          </Grid>
        </Grid>
      ) : (
        <StyledErrorMsg>{errorMsgs.APPLICANT_DETAIL_ERROR}</StyledErrorMsg>
      )}
      <StyledTitle>{titles.RAKTRACK_LEAD_REFERENCE_TITLE}</StyledTitle>
      {get(searchResult, "organizationInfo.leadNumber") ? (
        <Grid container spacing={3}>
          <Grid item md={6} sm={12}>
            <StyledCompanyDetailsWrapper>
              {searchResult.organizationInfo.leadNumber}
            </StyledCompanyDetailsWrapper>
          </Grid>
        </Grid>
      ) : (
        <StyledErrorMsg>{errorMsgs.RAKTRACK_LEAD_REFERENCE_ERROR}</StyledErrorMsg>
      )}
      <StyledTitle>{titles.COMPANY_DETAIL_TITLE}</StyledTitle>
      {get(prospectOverview, "organizationInfo.companyName") ? (
        <Grid container spacing={3}>
          <Grid item md={6} sm={12}>
            <StyledCompanyDetailsWrapper className={"companyNameColumn"}>
              {prospectOverview.organizationInfo.companyName}
            </StyledCompanyDetailsWrapper>
          </Grid>
          <Grid item md={6} sm={12}>
            <StyledCompanyDetailsWrapper>
              {prospectOverview.organizationInfo.licenseOrCOINumber}
            </StyledCompanyDetailsWrapper>
          </Grid>
        </Grid>
      ) : (
        <StyledErrorMsg>{errorMsgs.COMPANY_DETAIL_ERROR}</StyledErrorMsg>
      )}
      <StyledTitle>{titles.PARTNER_CODE_TITLE}</StyledTitle>
      {get(prospectOverview, "applicantInfo.allianceCode") ? (
        <Grid container spacing={3}>
          <Grid item md={6} sm={12}>
            <StyledCompanyDetailsWrapper>
              {prospectOverview.applicantInfo.allianceCode}
            </StyledCompanyDetailsWrapper>
          </Grid>
        </Grid>
      ) : (
        <StyledErrorMsg>{errorMsgs.PARTNER_CODE_ERROR}</StyledErrorMsg>
      )}
    </>
  );
};
